import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { faQrcode as QrCodeIcon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, ContentBox, Text } from '@looxr/components';
import { useTranslation } from '@looxr/utils';

const StyledAvatar = styled(Box)`
  padding: 20px;

  img {
    max-width: 100%;
  }

  div {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    overflow: hidden;
    font-size: 100px;
    color: ${(props) => props.theme.colors.grey};
  }
`;

const StyledAvatarBtns = styled(Box)`
  button {
    margin-right: 5px;
  }

  button:last-child {
    margin-right: 0;
  }
`;

const HiddenUploadInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  outline: 0;
  visibility: none;
  display: none;
  width: 100%;
  padding: 10px;
`;

function CustomerFormBrand({ customerData, imageSrc, onImageUpdate }) {
  const tn = useTranslation();
  const uploadRef = useRef();

  const onFileChange = (event) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const src = e.target.result;
      onImageUpdate(src);
    };

    // max 2MB
    const maxSize = 2 * 1024 * 1024;
    const file = event.target.files[0];

    // @TODO check type => make accept a constant and check there

    if (file && file.size <= maxSize) {
      // read the image file as a data URL.
      reader.readAsDataURL(event.target.files[0]);
    } else {
      alert('PNG oder JPG mit max. 2MB');
    }
  };

  const focusUpload = () => {
    uploadRef.current.click();
  };

  return (
    <>
      <ContentBox
        title={tn('admin.page.customerForm.branding.title')} // "Branding"
        marginTop={5}
      >
        <Box display="flex" direction="row" width="100%">
          <Box display="flex" width="50%">
            <HiddenUploadInput
              ref={uploadRef}
              id="branding.qrLogo"
              name="branding.qrLogo"
              autoComplete="off"
              type="file"
              accept=".png,.jpg,.jpeg"
              onInput={onFileChange}
              onClick={(event) => {
                // @TODO fix it
                // eslint-disable-next-line no-param-reassign
                event.target.value = null;
              }}
            />
            <Box display="flex" justify="center" direction="column">
              <StyledAvatar display="flex" justify="center" alignContent="center">
                {imageSrc ? (
                  <Box display="flex" justify="center" alignContent="center">
                    <img src={imageSrc} alt="QR-Code Logo" />
                  </Box>
                ) : (
                  <Box display="flex" justify="center" alignContent="center">
                    <FontAwesomeIcon icon={QrCodeIcon} />
                  </Box>
                )}
              </StyledAvatar>
              {!customerData.archived && (
                <>
                  <Text size="sm" color="grey" align="center">
                    {tn('admin.page.customerForm.branding.imageNotice')}
                    {/* PNG mit Transparentem Hintergrund max. 500Kb */}
                  </Text>
                  <StyledAvatarBtns display="flex" justify="center" direction="row">
                    <Button
                      width={150}
                      text={tn('general.chooseImage')} // "Auswählen"
                      background="green"
                      onClick={() => focusUpload()}
                    />
                    {imageSrc && (
                      <Button
                        width={150}
                        text={tn('general.delete')} // "Löschen"
                        background="red"
                        onClick={() => onImageUpdate(null)}
                      />
                    )}
                  </StyledAvatarBtns>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </ContentBox>
    </>
  );
}

CustomerFormBrand.propTypes = {
  customerData: PropTypes.any,
  imageSrc: PropTypes.any,
  onImageUpdate: PropTypes.func
};

CustomerFormBrand.defaultProps = {
  customerData: null,
  imageSrc: null,
  onImageUpdate: () => {}
};

export default CustomerFormBrand;
